export const PAGINATION_SIBLING_PAGE_NUMBERS_COUNT = 1;
export const PAGINATION_MAIN_PAGE_NUMBERS_COUNT = 5;
export const PAGINATION_FIRST_PAGE_NUMBER = 1;
export const PAGINATION_SIBLING_INDEX_BOUND = 2;
export const PAGINATION_DEFAULT_PAGE_NUMBERS_COUNT_WITH_ONE_DOTS = 3;
export const PAGINATION_SIBLING_PAGE_NUMBERS_COUNT_MULTIPLIER = 2;
export const PAGINATION_ADDITIONAL_PAGE_NUMBER = 1;
export const PAGINATION_DOTS_VALUE = 0;
